import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'vfs-select-search',
  templateUrl: './select-search.component.html',
  styleUrls: ['./select-search.component.scss']
})
export class SelectSearchComponent implements OnInit, AfterViewInit, OnDestroy {
  searchValue: string;
  @ViewChild('inputRef') inputRef;
  destroyed = new Subject();
  @Output() searchValueChange = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    fromEvent(this.inputRef.nativeElement, 'keyup')
      .pipe(
        takeUntil(this.destroyed),
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.searchValue = this.inputRef.nativeElement.value;
          this.searchValueChange.emit(this.inputRef.nativeElement.value.replace(/\s+/g, ' ').trim());
        })
      )
      .subscribe();
  }

  stopPropagation(event) {
    if (event.key === ' ') {
      event.stopPropagation();
    }
  }

  removeFilters() {
    this.inputRef.nativeElement.value = '';
    this.searchValue = '';
    this.searchValueChange.emit('');
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed = null;
  }
}
